import { useEffect, useRef } from "react";
import { WORKFLOW_ANSWER_VISIBLE } from "../../utils/workflowDelivery";

export const useWorkflowAnswerReceipt = (message, fallbackId) => {
  const ref = useRef(null);
  const id = message?.id || fallbackId;
  const ready = message?.sender === "bot" && /^\d+$/.test(String(id)) &&
    !message?._workspaceStreaming && message?.textStreamCompleted !== false &&
    !message?.isError && !message?.is_error && Boolean(message?.message?.trim());
  useEffect(() => {
    if (!ready || !ref.current || typeof IntersectionObserver === "undefined") return undefined;
    let visible = false;
    let frame;
    const publish = () => {
      cancelAnimationFrame(frame);
      if (!visible || document.visibilityState !== "visible") return;
      frame = requestAnimationFrame(() => {
        frame = requestAnimationFrame(() => {
          if (visible && document.visibilityState === "visible") {
            window.dispatchEvent(new CustomEvent(WORKFLOW_ANSWER_VISIBLE, { detail: { messageId: id } }));
          }
        });
      });
    };
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; publish(); });
    observer.observe(ref.current);
    document.addEventListener("visibilitychange", publish);
    return () => { observer.disconnect(); cancelAnimationFrame(frame); document.removeEventListener("visibilitychange", publish); };
  }, [id, ready]);
  return ref;
};
